import React from 'react';

import { useUrlModals } from '../../hooks/useUrlModals';

const UrlModalHandler: React.FC<{children: React.ReactNode}> = ({ children }) => {
  useUrlModals();
  return <>{children}</>;
};

export default UrlModalHandler;
